class ColourVariants extends HTMLElement {
  constructor() {
    super();

    this.variants = this.querySelectorAll(".js-variant-colour");
    this.quickAddModal = this.closest('quick-add-modal');
    this.isQuickAdd = this.quickAddModal ? true : false;
    this.parent = this.closest(".product__info-container");

    this.variants.forEach((el) => {
      el.addEventListener("click", () => {
        const url = el.getAttribute("data-product");
        if (url != window.location.pathname) {
          el.classList.add("loading");
          this.changeProduct(url, el);
        }
      });
    });
  }

  changeProduct(url, el) {
    fetch(`${url}?section_id=product-details-table`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        //product details table
        const detailsRows = html.querySelectorAll(".js-product-details tr");
        if (detailsRows.length) {
          detailsRows.forEach((row) => {
            if (document.getElementById(row.getAttribute("id"))) {
              document.getElementById(row.getAttribute("id")).innerHTML =
                row.innerHTML;
            }
          });
        }
      });

    fetch(`${url}?section_id=main-product`)
      .then((response) => response.text())
      .then((responseText) => {
        if (!this.isQuickAdd) {
          const newUrl = new URL(window.location);
          newUrl.pathname = url;

          window.history.replaceState(
            {},
            "",
            `${newUrl.pathname}${newUrl.search}`
          );
        }

        const variantRadios = this.parent.querySelector("variant-radios");
        if (variantRadios) {
          variantRadios.setAttribute("data-url", url);
        }

        const html = new DOMParser().parseFromString(responseText, "text/html");

        // Quick Add Modal
        if (this.isQuickAdd) {
          const quickAddSource = html.querySelector(".quick-add-top");
          const quickAddDestination = this.quickAddModal.querySelector(".quick-add-top");
          if (quickAddSource && quickAddDestination)
            quickAddDestination.innerHTML = quickAddSource.innerHTML;
        }

        if (!this.isQuickAdd) {
          //media
          const mediaSource = html.querySelector(".product__media-wrapper");
          const mediaDestination = document.querySelector(
            ".product__media-wrapper"
          );
          if (mediaSource && mediaDestination)
            mediaDestination.innerHTML = mediaSource.innerHTML;

          //breadcrumb
          const breadcrumbSource = html.querySelector(".breadcrumbs");
          const breadcrumbDestination = document.querySelector(".breadcrumbs");
          if (breadcrumbSource && breadcrumbDestination)
            breadcrumbDestination.innerHTML = breadcrumbSource.innerHTML;

          //complete the set
          const additionsSource = html.querySelector(".js-product-additions");
          const additionsDestination = document.querySelector(
            ".js-product-additions"
          );
          if (additionsSource && additionsDestination)
            additionsDestination.innerHTML = additionsSource.innerHTML;

          //product top
          const productTopSource = html.querySelector(".product__top");
          const productTopDestination = document.querySelector(".product__top");
          if (productTopSource && productTopDestination)
            productTopDestination.innerHTML = productTopSource.innerHTML;
        }

        //product lower
        const productLowerSource = html.querySelector(".product__lower");
        const productLowerDestination =
          this.parent.querySelector(".product__lower");
        if (productLowerSource && productLowerDestination)
          productLowerDestination.innerHTML = productLowerSource.innerHTML;

        const checkedRadioBeforeUpdate = this.parent.querySelector("input[type='radio']:checked");
        const variantsSource = html.querySelector(".product__options-picker");
        const variantsDestination = this.parent.querySelector(".product__options-picker");
        if (variantsSource && variantsDestination) {
          const radiosToUpdate = variantsSource.querySelectorAll("input[type='radio']");
          radiosToUpdate.forEach(radio => {
            radio.checked = false;
            radio.removeAttribute('checked');

            if (radio.value === checkedRadioBeforeUpdate.value) {
              radio.checked = true;
              radio.setAttribute('checked', 'checked');
            }
          });

          variantsDestination.innerHTML = variantsSource.innerHTML;
        }

        //colour value
        const colourSource = html.querySelector(
          "product-colour-variants .js-option-value"
        );
        const colourDestination = this.parent.querySelector(
          "product-colour-variants .js-option-value"
        );
        if (colourSource && colourDestination)
          colourDestination.innerHTML = colourSource.innerHTML;

      })
      .finally(() => {
        el.classList.remove("loading");
        this.removeActiveClasses();
        el.classList.add("active");
      });
  }

  removeActiveClasses() {
    this.variants.forEach((el) => {
      el.classList.remove("active");
    });
  }
}

customElements.define("product-colour-variants", ColourVariants);
